import { render, staticRenderFns } from "./client-list-settings-modal.vue?vue&type=template&id=1572fb86&scoped=true"
import script from "./client-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./client-list-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572fb86",
  null
  
)

export default component.exports